var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52.5,
    r: 45.5,
    fill: "#FEF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0312 26.5C80.0312 25.8269 80.5769 25.2813 81.25 25.2813L92.625 25.2813C93.2981 25.2813 93.8438 25.8269 93.8438 26.5C93.8438 27.1731 93.2981 27.7188 92.625 27.7188L81.25 27.7188C80.5769 27.7188 80.0312 27.1731 80.0312 26.5Z",
    fill: "#F7BA97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21875 67.125C1.21875 66.4519 1.7644 65.9062 2.4375 65.9062H13.8125C14.4856 65.9062 15.0312 66.4519 15.0312 67.125C15.0312 67.7981 14.4856 68.3438 13.8125 68.3438H2.4375C1.7644 68.3438 1.21875 67.7981 1.21875 67.125Z",
    fill: "#F7BA97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9062 32.1875C84.9062 31.5144 85.4519 30.9688 86.125 30.9688L91 30.9688C91.6731 30.9688 92.2188 31.5144 92.2188 32.1875C92.2188 32.8606 91.6731 33.4063 91 33.4063L86.125 33.4062C85.4519 33.4062 84.9062 32.8606 84.9062 32.1875Z",
    fill: "#F7BA97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09375 72.8125C6.09375 72.1394 6.6394 71.5938 7.3125 71.5938H12.1875C12.8606 71.5938 13.4062 72.1394 13.4062 72.8125C13.4062 73.4856 12.8606 74.0312 12.1875 74.0312H7.3125C6.6394 74.0312 6.09375 73.4856 6.09375 72.8125Z",
    fill: "#F7BA97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0938 26.5C97.0938 25.8269 97.6394 25.2812 98.3125 25.2812H101.562C102.236 25.2812 102.781 25.8269 102.781 26.5C102.781 27.1731 102.236 27.7188 101.562 27.7188H98.3125C97.6394 27.7188 97.0938 27.1731 97.0938 26.5Z",
    fill: "#F7BA97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0625 62.0892C30.0625 61.4161 30.6082 60.8704 31.2812 60.8704H42.265C42.9381 60.8704 43.4838 61.4161 43.4838 62.0892C43.4838 62.7623 42.9381 63.3079 42.265 63.3079H31.2812C30.6082 63.3079 30.0625 62.7623 30.0625 62.0892Z",
    fill: "#E9688A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4574 68.6791C34.4574 68.006 35.003 67.4603 35.6761 67.4603H48.8567C49.5298 67.4603 50.0754 68.006 50.0754 68.6791C50.0754 69.3522 49.5298 69.8978 48.8567 69.8978H35.6761C35.003 69.8978 34.4574 69.3522 34.4574 68.6791Z",
    fill: "#E9688A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2483 36.7409C43.0023 36.7409 34.6962 45.0469 34.6962 55.293C34.6962 55.9661 34.1506 56.5117 33.4775 56.5117C32.8044 56.5117 32.2587 55.9661 32.2587 55.293C32.2587 43.7007 41.6561 34.3034 53.2483 34.3034C64.8405 34.3034 74.2379 43.7007 74.2379 55.293C74.2379 66.8852 64.8405 76.2825 53.2483 76.2825H42.2645C41.5914 76.2825 41.0458 75.7369 41.0458 75.0638C41.0458 74.3907 41.5914 73.845 42.2645 73.845H53.2483C63.4943 73.845 71.8004 65.539 71.8004 55.293C71.8004 45.0469 63.4943 36.7409 53.2483 36.7409Z",
    fill: "#E9688A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6371 29.3438C47.6371 28.6707 48.1828 28.125 48.8559 28.125H57.6429C58.316 28.125 58.8616 28.6707 58.8616 29.3438C58.8616 30.0168 58.316 30.5625 57.6429 30.5625H48.8559C48.1828 30.5625 47.6371 30.0168 47.6371 29.3438Z",
    fill: "#E9688A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2483 47.6895C53.9214 47.6895 54.4671 48.2351 54.4671 48.9082V57.6953C54.4671 58.3684 53.9214 58.914 53.2483 58.914C52.5752 58.914 52.0296 58.3684 52.0296 57.6953V48.9082C52.0296 48.2351 52.5752 47.6895 53.2483 47.6895Z",
    fill: "#E9688A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/storeIcon.2d421292e0108de38814a7ca2aae6e7e.svg";
export { ForwardRef as ReactComponent };